import {tracking_events} from '@utilities/track-abstract/track-abstract';

// "<!-- Facebook Pixel Code -->
// <script>
// !function(f,b,e,v,n,t,s)
// {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
//     n.callMethod.apply(n,arguments):n.queue.push(arguments)};
//     if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
//     n.queue=[];t=b.createElement(e);t.async=!0;
//     t.src=v;s=b.getElementsByTagName(e)[0];
//     s.parentNode.insertBefore(t,s)}(window, document,'script',
//     'https://connect.facebook.net/en_US/fbevents.js');
// fbq('init', '751039465466204');
// fbq('track', 'PageView');
// </script>
// <noscript><img height=""1"" width=""1"" style=""display:none""
// src=https://www.facebook.com/tr?id=751039465466204&ev=PageView&noscript=1
// /></noscript>
// <!-- End Facebook Pixel Code -->"

// https://developers.facebook.com/docs/facebook-pixel/implementation#base-code
// https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking
// https://developers.facebook.com/docs/facebook-pixel/reference#standard-events


// (/) Page view
// (/) Add to cart: 	bei jeder Aktion, wenn ein Item zum Warenkorb hinzugefügt wird (Musterbestellung, Downloadauftrag)
// ( ) Lead: 	„Beim Händler anfragen“ (Produktverfügbarkeit) als Lead tracken
// (-) Complete registration: 	bei jedem erfolgreichen Login und Neu-Registrierung  =>  SSO-Seite
// ( ) Contact: 	Email, Telefonnummer, Kontakt anfragen
// (-) Subscribe: 	Newsletter  =>  SSO-Seite

let tracking_started = false;

const sal_fbq = {
    start_tracking: () => {
        if (tracking_started) {
            return;
        } else {
            tracking_started = true;
        }

        let fbid = false;
        if (document.location.hostname.indexOf('pfleiderer.com') !== -1) {
            fbid = '751039465466204';
        } else if (document.location.hostname.indexOf('ddev.site')) {
            fbid = '978053609634679';
        }

        if (fbid !== false) {
            !function(f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function() {
                    n.callMethod ?
                        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = '2.0';
                n.queue = [];
                t = b.createElement(e);
                t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s)
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            window.fbq('init', fbid);
            window.fbq('track', 'PageView');


            // Sehr spezielles Custom Event Tracking
            if (document.location.pathname === '/dach-de/service/digitale-services/workapp-info') {
                document.querySelectorAll('.ce-text-image .ce-bodytext .button').forEach((element) => {
                    element.addEventListener('click', () => {
                        window.fbq('trackCustom', 'Workapp');
                    });
                });
            } else if (document.location.pathname === '/dach-de/service/downloads/woodpro-planungsdaten') {
                document.querySelectorAll('.ce-text-image .ce-bodytext .button, .keyvisual-abstract .button').forEach((element) => {
                    element.addEventListener('click', () => {
                        window.fbq('trackCustom', 'Woodpro');
                    });
                });
            }
        }

        // Initial Page Events
        if (Array.isArray(window.facebookInitialEvents)) {
            window.facebookInitialEvents.forEach(event => {
                const [category, customEventName] = event;
                if (!category || (category === 'custom' && !customEventName)) {
                    return;
                }
                if (category === 'custom') {
                    window.fbq('trackCustom', customEventName);
                } else {
                    window.fbq('track', category, {});
                }
            });
        }
    },
    track_event: (event, payload) => {
        if (window.fbq) {
            switch (event) {
            case tracking_events.ClickEmail: // payload = email
            case tracking_events.ClickPhone: // payload = number
                // Klick auf Mailto:Links
                // Klick auf Tel:Links
                window.fbq('track', 'Contact', {});
                break;
                // Klick auf Add To Warenkorb
            case tracking_events.AddToCart: // payload = { id, title, subtitle, subsubtitle }
                window.fbq('track', 'AddToCart', {
                    content_ids: payload.id,
                    content_name: payload.title + " " + payload.subtitle + " " + payload.subsubtitle
                });
                break;
                // Klick auf Ask a Distributor
            case tracking_events.AddToDealerRequest:
                window.fbq('track', 'Lead', {});
                break;
            case tracking_events.ClickNewsletter:
                window.fbq('track', 'Subscribe', {});
                break;
            case tracking_events.ClickLogin:
            case tracking_events.ClickRegister:
                window.fbq('track', 'CompleteRegistration')
                break;
                // Moodboard Upload
            case tracking_events.MoodboardUpload:
                window.fbq('trackCustom', 'Moodboard');
                break;
            }
        }
    }
};

export {sal_fbq};
